<script setup>
import {defineEmits} from 'vue';
const emit = defineEmits(['gridRowStateClick']);
const props = defineProps({
  propsData: {
    type: Array,
    default: () => [],
  },
  rowIndex: {
    default: 0,
    type: Number,
  },
  dataRow: {
    default: {},
    type: Object,
  },
});

const clickIcon = (metaData, rowIndex) => {
  if (metaData.name !== 'drag') {
    emit('gridRowStateClick', metaData, rowIndex);
  }
};
</script>

<template>
  <div class="flex-row flex-center">
    <template v-for="(item, index) in propsData" :key="index">
      <span v-if="item.type === 'boolean'" class="cell-checkbox mr-2" @click="clickIcon(item, rowIndex)">
        <div class="icon" :class="{checked: dataRow[item.field]}"></div>
      </span>
      <div
        v-else
        class="icon24 row-editor-action mr-2"
        :title="item.title"
        :class="[
          item.name.toString().toLowerCase(),
          {'drag-data': item.name.toString().toLowerCase() === 'drag'},
          {disabled: !dataRow[item.field]},
        ]"
        @click="clickIcon(item, rowIndex)"
      ></div>
    </template>
  </div>
</template>

<style lang="scss" scoped>
.before-last {
  margin-right: 4px;
}
.drag-data {
  cursor: move;
  &::before {
  }
}
</style>
